import React from "react";
import PhotoProducts from "../PhotoProducts/PhotoProducts";
import "./Products.scss";
import {Grid} from "@mui/material";

const Products = ({ products = [], asset}) => {
    return <Grid item id={"desktop-products"} xs={12} lg={6}>
        <div className={"products-wrapper"}>
            <div className={"products-holder1"}>
                <PhotoProducts asset={asset} products={products}/>
            </div>
        </div>
    </Grid>
    
}

export default Products;